import axios from '../base.js'

export default class SSGJ {
  static async getssgj(params) {
    let res = await axios.get('/data/SSGJ/getssgj.json')
    let fil = []
    res.data.data.forEach(ele => {
      if (params == '全部') {
        fil.push(ele)
      } else {
        fil = res.data.data.filter(f => {
          if (f.category == params) {
            return f
          }
        })
      }
    })
    return fil
  }
  static async getgjxx(params) {
    let res = await axios.get(`/data/SSGJ/getgjxx/getgjxx${params}.json`)
    return res.data.data
  }
  static async getjcxx(params) {
    let res = await axios.get(`/data/SSGJ/getjcxx/getjcxx${params}.json`)
    return res.data.data
  }
  // 获取G5栋告警信息
  static async reqgetDaLougjxx(p) {
    let res = await axios.get(`/data/SSGJ/getDaLougjxx${p}.json`)
    return res.data.data
  }

  static async getztxx(params) {
    let res = await axios.get(`/data/SSGJ/getztxx/getztxx${params}.json`)
    return res.data.data
  }
}
